// extracted by mini-css-extract-plugin
export default {"container":"NoProfile_container__0QNWk","buttonLink":"NoProfile_buttonLink__qqeXZ"};